import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useTranslation } from "react-i18next";
import "../../css/components/Calendar/RefutalNotificationModal.css";
import "../../css/main.css";

const NoWorkspacesModal = ({ open, onClose, message }) => {
    const { t } = useTranslation();

    return (
        <Modal open={open} onClose={onClose}>
            <Box className="refutal-notification-modal">
                <Typography variant="h6" component="h2" className="refutal-notification-title">
                    {t("modal.no_workspace_title")}
                </Typography>
                <Typography variant="body1" className="refutal-notification-text">
                    {message}
                </Typography>
                <Box className="refutal-notification-button-box">
                    <Button variant="contained" className="button-dark-bg" onClick={onClose}>
                        {t("modal.no_workspace_acknowledge")}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default NoWorkspacesModal;
